/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface WebResultBadgeSeriesResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  /** List of badge series */
  obj?: BadgeSeriesCompositeVO[];
  msgKey?: string;
}

/** 团队已解锁的徽章列表 */
export interface TeamBadgeItem {
  /** 徽章配置ID */
  badgeConfigId?: string;
  /** 用户是否参与解锁 */
  involved?: boolean;
  /**
   * 等级
   * @format int32
   */
  level?: number;
  /**
   * 荣誉分
   * @format int32
   */
  honorScore?: number;
  /**
   * 解锁时间（UTC毫秒）
   * @format int64
   */
  unlockedAt?: number;
  /**
   * 进度百分比
   * @format int32
   */
  progress?: number;
  /**
   * 当前徽章数量
   * @format int32
   */
  currentBadgeCount?: number;
  /** 团队徽章对应的个人徽章ID集合 从unlockConditions中解析出type为BADGE_HOLDERS对应的badgeId集合 */
  requiredPersonalBadgeIds?: string[];
  /** 团队徽章对应的个人徽章详情列表 */
  requiredPersonalBadges?: BadgeVO[];
  /** 团队徽章对应的个人徽章详情列表 */
  teamBadgeDetail?: BadgeVO;
  /** 解锁状态 */
  status?: string;
  /**
   * 解锁所需徽章数量
   * @format int32
   */
  requiredBadgeCount?: number;
}

export interface WebResultPurchaseResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: MintRequest;
  msgKey?: string;
}

export interface WebResultNotificationReadResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultNotificationReadResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultTeamApplicationsResponseAllOfObj {
  /** 分页信息 */
  pagination?: WebResultTeamApplicationsResponseAllOfObjPagination;
  /** 申请列表 */
  applications?: TeamApplicationItem[];
}

export interface WebResultWalletDexPairStatesResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultWalletDexPairStatesResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultGrantBadgeResponseVO {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultGrantBadgeResponseVOAllOfObj;
  msgKey?: string;
}

export interface UpdateTeamRequest {
  /** 战队名称 */
  teamName?: string;
  /** 战队头像URL */
  avatarUrl?: string;
  /** 战队背景图片URL */
  backgroundImage?: string;
  /** 是否开启入队审核（仅 private 类型战队可开启） */
  joinAudit?: boolean;
  /** 战队描述 */
  description?: string;
  /** 战队类型：public(公开)/private(私有) */
  teamType?: string;
  /**
   * 队长用户ID
   * @example "user_captain123"
   */
  captainUserId: string;
}

/** NFT持有项列表 */
export interface NftHoldingItem {
  /**
   * 当前持有数量（持有时间超过minHoldingTimestamp的）
   * @format int64
   */
  quantity: number;
  /** 链ID */
  chainId: string;
  /** NFT合约地址 */
  contractAddress: string;
  /** 当前持有的tokenId列表（持有时间超过minHoldingTimestamp的） */
  tokenIds?: string[];
}

export interface WebResultCheckEventResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  msgKey?: string;
}

export interface WebResultNotificationsResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultNotificationsResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultCheckResultResponseAllOfObj {
  /**
   * 最后一次检查时间戳
   * @format int64
   */
  lastCheckTimestamp?: number;
  /**
   * 可领取徽章数量
   * @format int64
   */
  claimableBadgeCount?: number;
}

export interface WebResultUpdateTeamResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: TeamVO;
  msgKey?: string;
}

export interface WebResultUpdateSocialPrivacyResponseAllOfObj {
  /**
   * 更新后的社媒隐私状态
   * @example "teamOnly"
   */
  socialPrivacy?: "public" | "teamOnly" | "private";
  /**
   * 操作是否成功
   * @example true
   */
  success?: boolean;
  /**
   * 用户ID
   * @example "user_001"
   */
  userId?: string;
}

export interface WebResultRemoveMemberResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: TeamRemoveResponse;
  msgKey?: string;
}

export interface WebResultApplicationActionResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultApplicationActionResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultMemberRankingResponseAllOfObj {
  leaderboard?: MemberRankingItem[];
  pagination?: WebResultMemberRankingResponseAllOfObjPagination;
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
}

export interface WebResultBadgeAssetsResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  /** Badge assets data */
  obj?: WebResultBadgeAssetsResponseAllOfObj;
  msgKey?: string;
}

export interface AssetsBadgeResponse {
  /** all nfts in series */
  nfts?: NftVO[];
  /** 用户id */
  customerId?: string;
}

export interface MemberRankingItem {
  /** contribution description */
  isCurrentUser?: string;
  /** 社媒信息权限 public 完全公开 /teamOnly 团队内可见 /private 完全私密 */
  socialPrivacy?: string;
  /** contribution description */
  role?: string;
  /** contribution value */
  avatarUrl?: string;
  /**
   * contribution description
   * @format int64
   */
  joinedAt?: number;
  /** user name */
  rank?: string;
  /** contribution description */
  invitationRewardScore?: string;
  /** contribution description */
  individualHonorScore?: string;
  /** contribution type */
  userName?: string;
  /** user avatar url */
  userId?: string;
  socialMediaInfo?: SocialMediaInfo;
  /** contribution description */
  totalHonorScore?: string;
}

/** 团队已解锁的徽章列表 */
export interface TeamRankingItemUnlockedBadgesInner {
  /** 徽章配置ID */
  badgeConfigId?: string;
  /** 徽章名称 */
  badgeName?: string;
  /**
   * 等级
   * @format int32
   */
  level?: number;
  /**
   * 荣誉分
   * @format int32
   */
  honorScore?: number;
  /**
   * 解锁时间
   * @format int64
   */
  unlockedAt?: number;
  /**
   * 进度百分比
   * @format int32
   */
  progress?: number;
  /** 描述 */
  description?: string;
  /** 徽章系列 */
  badgeSeries?: string;
  /** 徽章图片URL */
  badgeImage?: string;
  /** 团队徽章对应的个人徽章详情列表 */
  teamBadgeDetail?: BadgeVO;
  /** 稀有度 */
  rarity?: string;
  /** 解锁状态 */
  status?: string;
}

export interface DocPaginationRowsInner {
  /** 团队名称 */
  teamName?: string;
  /** 队长用户handle */
  captainHandle?: string;
  /** 团队头像 */
  avatarUrl?: string;
  /** 团队背景图 */
  backgroundImage?: string;
  /**
   * 成员数量
   * @format int32
   */
  memberCount?: number;
  /** 团队描述 */
  description?: string;
  /**
   * 创建时间
   * @format int64
   */
  createdAt?: number;
  /**
   * 最大成员数量
   * @format int32
   */
  maxMembers?: number;
  /** 团队id */
  teamId?: string;
  /**
   * 荣誉积分
   * @format int32
   */
  honorScore?: number;
  /**
   * 团队排名
   * @format int32
   */
  rank?: number;
  /** 团队类型 */
  teamType?: string;
  /** 队长用户id */
  captainUserId?: string;
  /**
   * 总荣誉积分
   * @format int32
   */
  totalHonorScore?: number;
  /** 团队状态 */
  status?: string;
  /**
   * 更新时间
   * @format int64
   */
  updatedAt?: number;
}

export interface WebResultBadgesCompositeResponseAllOfObj {
  imprint?: ImprintVO;
  /** List of badges filtered by conditions */
  tokens?: BadgeVO[];
}

/** 分页信息 */
export interface WebResultTeamLeaderboardResponseAllOfObjPagination {
  /**
   * 总页数
   * @format int32
   */
  totalPages?: number;
  /**
   * 每页条数
   * @format int32
   */
  pageSize?: number;
  /**
   * 当前页码
   * @format int32
   */
  currentPage?: number;
  /**
   * 总记录数
   * @format int32
   */
  totalCount?: number;
}

/** NFT信息列表 */
export interface NftHoldingByDurationRequestNftInfosInner {
  /** 链ID */
  chainId: string;
  /** NFT合约地址 */
  contractAddress: string;
}

export interface UpdateSocialPrivacyRequest {
  /**
   * 社媒隐私状态：public(公开)/teamOnly(仅队友可见)/private(私密)
   * @example "teamOnly"
   */
  socialPrivacy: "public" | "teamOnly" | "private";
  /**
   * 用户ID
   * @example "user_001"
   */
  userId: string;
}

export interface WebResultMemberProfileResponseAllOfObjScores {
  /**
   * 邀请奖励积分
   * @format int32
   * @example 250
   */
  invitationRewardScore?: number;
  /**
   * 个人荣誉积分
   * @format int32
   * @example 2200
   */
  individualHonorScore?: number;
  /**
   * 总荣誉积分
   * @format int32
   * @example 2450
   */
  totalHonorScore?: number;
}

/** 钱包在各链、各DEX交易对上的汇总状态 */
export interface WebResultWalletDexPairStatesResponseAllOfObjPairStates {
  /** 报价代币地址 */
  quoteTokenAddress?: string;
  /** 基础代币地址 */
  baseTokenAddress?: string;
  /**
   * 首次交易时间戳（毫秒）
   * @format int64
   */
  firstTransactionTime?: number;
  /** 交易对标识（例如 WBTC/WETH、SANTA/SOL） */
  pairLabel?: string;
  /** DEX 合约地址 */
  dexAddress?: string;
  /** 交易对地址（流动性池合约地址） */
  pairAddress?: string;
  /** 链标识（例如 ethereum、solana、polygon、bsc） */
  chainId?: string;
  /** DEX 协议名称（例如 uniswapv3、sushiswapv3） */
  dex?: string;
  /**
   * 该钱包-链-DEX-交易对上的交易笔数
   * @format int32
   */
  transactionCount?: number;
  /**
   * 最近一次拉取该钱包-链-DEX-交易对数据的时间戳（毫秒）
   * @format int64
   */
  lastFetchTime?: number;
  /** 钱包地址 */
  walletAddress?: string;
  /**
   * 最近一次交易时间戳（毫秒）
   * @format int64
   */
  lastTransactionTime?: number;
  /** 该钱包-链-DEX-交易对上的 USD 总价值 */
  totalValueUsd?: string;
  /** 交易对状态（ACTIVE、INACTIVE、ERROR） */
  status?: string;
}

export interface WebResultBadgeContributorsResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultBadgeContributorsResponseAllOfObj;
  msgKey?: string;
}

/** Badge check result */
export interface WebResultBadgeCheckResponseAllOfObj {
  /** List of claimable badges */
  badges?: BadgeVO[];
  /**
   * Last check timestamp
   * @format int64
   */
  lastCheckTimestamp?: number;
  /**
   * Number of claimable badges
   * @format int32
   */
  claimableCount?: number;
}

/** all nfts in series */
export interface NftVO {
  /**
   * minted Count
   * @format int64
   */
  mintedCount?: number;
  /** nft series logo */
  seriesLogo?: string;
  /** claimable id */
  claimableId?: string;
  /** nft type */
  type?: string;
  /**
   * nft tier
   * @format int32
   */
  tier?: number;
  /** price */
  price?: string;
  /** nft gateway logo */
  logo?: string;
  /**
   * reward
   * @format int32
   */
  reward?: number;
  /** show new tag */
  newTag?: boolean;
  /** nft complete process */
  process?: number;
  /** nft contract address */
  address?: string;
  /** nft token id */
  tokenId?: string;
  /** level */
  level?: string;
  /** nft series name */
  seriesName?: string;
  /**
   * total supply
   * @format int64
   */
  totalSupply?: number;
  /**
   * token sort
   * @format int32
   */
  sort?: number;
  /** nft condition max */
  maxCond?: number;
  /**
   * nft claimed time
   * @format int64
   */
  claimTime?: number;
  /** currency */
  token?: string;
  /** nft series type */
  series?: string;
  /** nft condition min */
  minCond?: number;
  /** nft name */
  name?: string;
  /** nft conditions and progress */
  progress?: NftProgressVO[];
  /** category */
  category?: string;
  /** business type */
  businessType?: string;
  /** nft desc */
  desc?: string;
  /** nft status(pending、claimable、claimed) */
  status?: string;
  /** nft rarity */
  rarity?: string;
}

/** nft conditions and progress */
export interface NftProgressVO {
  /** condition number */
  condition?: string;
  /** condition name */
  name?: string;
  /** condition type */
  type?: string;
  /** progress value */
  value?: string;
}

export interface WebResultBadgeResponseAllOfObj {
  /**
   * total count
   * @format int64
   */
  total?: number;
  nextToken?: string;
  rows?: BadgeVO[];
}

/** 分页信息 */
export interface WebResultTeamApplicationsResponseAllOfObjPagination {
  /**
   * 总页数
   * @format int32
   * @example 8
   */
  totalPages?: number;
  /**
   * 每页条数
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * 当前页码
   * @format int32
   * @example 1
   */
  currentPage?: number;
  /**
   * 总记录数
   * @format int64
   * @example 150
   */
  totalCount?: number;
}

export interface WebResultUserOpHashProcess {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: string;
  msgKey?: string;
}

export interface WebResultNotificationReadResponseAllOfObj {
  /**
   * 是否已读
   * @example true
   */
  isRead?: boolean;
  /**
   * 通知ID
   * @example "notif_1234567890"
   */
  notificationId?: string;
  /**
   * 读取时间的时间戳（毫秒）
   * @format int64
   * @example 1672531200000
   */
  readAt?: number;
  /**
   * 通知状态
   * @example "READ"
   */
  status?: string;
}

export interface WebResultCreateTeamResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: TeamVO;
  msgKey?: string;
}

export interface DenyApplicationRequest {
  /**
   * 拒绝原因
   * @minLength 1
   * @maxLength 200
   * @example "团队目前已满，暂时无法接受新成员"
   */
  reason: string;
}

export interface WebResultBadgeClaimableListResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  /** Pagination information */
  pagination?: WebResultBadgeClaimableListResponseAllOfPagination;
  success?: boolean;
  /** List of claimable badges */
  obj?: BadgeVO[];
  msgKey?: string;
}

export interface WebResultApplicationActionResponseAllOfObj {
  /**
   * 操作是否成功
   * @example true
   */
  success?: boolean;
  /**
   * 申请ID
   * @example "app_1234567890"
   */
  applicationId?: string;
  /**
   * 操作时间戳（毫秒）
   * @format int64
   * @example 1672617600000
   */
  timestamp?: number;
}

export interface WebResultMemberProfileResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultMemberProfileResponseAllOfObj;
  msgKey?: string;
}

/** 徽章总结信息 */
export interface WebResultTeamDetailResponseAllOfObjBadgeSummary {
  /**
   * 已解锁的徽章总数
   * @format int32
   * @example 12
   */
  totalUnlocked?: number;
  /**
   * 徽章总荣誉积分
   * @format int32
   * @example 6200
   */
  totalHonorScore?: number;
}

export interface WebResultBadgeClaimSignatureResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  /** Badge claim signatures */
  obj?: WebResultBadgeClaimSignatureResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultIntervalResetResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  msgKey?: string;
}

export interface TeamRemoveResponse {
  /** 移除原因 */
  reason?: string;
  /** 团队id */
  teamId?: string;
  /** 移除操作人id */
  removedBy?: string;
  /**
   * 移除时间戳，单位毫秒
   * @format int64
   */
  removedAt?: number;
  /** 被移除用户id */
  removedUserId?: string;
  /**
   * 成功移除成员数量
   * @format int32
   */
  removedSuccessCount?: number;
}

export interface BadgesHolderResponse {
  /** 用户钱包地址 */
  address?: string;
  /** token id */
  tokenId?: string;
  /** 用户id */
  customerId?: string;
  /** badge 合约地址 */
  contractAddress?: string;
  /**
   * 领取时间
   * @format int64
   */
  timestamp?: number;
}

export interface WebResultLeaveTeamResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: TeamLeaveResponse;
  msgKey?: string;
}

export interface MintRequest {
  uid?: string;
  /** @format int64 */
  quantity?: number;
  /** token id */
  tokenId?: string;
  signature?: string;
  chainId?: string;
  price?: string;
  contractAddress?: string;
  currency?: string;
  /** @format int64 */
  validityEndTimestamp?: number;
  id?: string;
  /** @format int64 */
  validityStartTimestamp?: number;
  projectHandle?: string;
}

export interface WebResultTeamDetailResponseAllOfObj {
  /**
   * 团队排名
   * @format int32
   * @example 150
   */
  globalRank?: number;
  /**
   * 社媒信息权限 public 完全公开 /teamOnly 团队内可见 /private 完全私密
   * @example "teamOnly"
   */
  socialPrivacy?: string;
  /** 团队已解锁的徽章列表 */
  unlockedBadges?: TeamBadgeItem[];
  /** 队长用户名 */
  captainUserName?: string;
  /**
   * 团队头像URL
   * @example "https://example.com/team-avatar.jpg"
   */
  avatarUrl?: string;
  /**
   * 团队背景图片URL
   * @example "https://example.com/team-bg.jpg"
   */
  backgroundImage?: string;
  /**
   * 当前成员数量
   * @format int32
   * @example 45
   */
  memberCount?: number;
  /**
   * 团队描述
   * @example "Top performers unite"
   */
  description?: string;
  socialMediaInfo?: SocialMediaInfo;
  /**
   * 创建时间的时间戳（毫秒）
   * @format int64
   * @example 1672531200000
   */
  createdAt?: number;
  /**
   * 最大成员数量
   * @format int32
   * @example 50
   */
  maxMembers?: number;
  /**
   * 当前用户在团队中的角色
   * @example "MEMBER"
   */
  myRole?: string;
  /** 徽章总结信息 */
  badgeSummary?: WebResultTeamDetailResponseAllOfObjBadgeSummary;
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 是否开启入队审核
   * @example true
   */
  joinAudit?: boolean;
  /**
   * 团队名称
   * @example "Elite Hunters"
   */
  name?: string;
  /**
   * 当前用户加入团队的时间戳（毫秒）
   * @format int64
   * @example 1672531200000
   */
  myJoinedAt?: number;
  /**
   * 团队类型
   * @example "PRIVATE"
   */
  teamType?: string;
  /** 团队徽章分类列表 */
  badgeCategories?: string[];
  /** 队长用户ID */
  captainUserId?: string;
  /**
   * 团队总荣誉积分
   * @format int32
   * @example 98750
   */
  totalHonorScore?: number;
  /**
   * 团队状态
   * @example "ACTIVE"
   */
  status?: string;
  /**
   * 最后更新时间的时间戳（毫秒）
   * @format int64
   * @example 1672617600000
   */
  updatedAt?: number;
}

export interface WebResultBadgesCompositeResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultBadgesCompositeResponseAllOfObj;
  msgKey?: string;
}

/** 每个钱包地址对应的代币余额信息 */
export interface TokenBalanceInfo {
  /** 钱包地址 */
  wallet_address: string;
  /** 代币余额（使用字符串以处理大数字） */
  balance: string;
  /** 链标识符 */
  chain_id: string;
  /**
   * 代币精度（小数位数）
   * @format int32
   */
  decimals: number;
  /** 代币合约地址 */
  token_address: string;
}

export interface WebResultCheckResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  msgKey?: string;
}

export interface WebResultBadgesHoldersResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultBadgesHoldersResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultTeamLeaderboardResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultTeamLeaderboardResponseAllOfObj;
  msgKey?: string;
}

export interface IntervalResetRequest {
  /** series */
  series?: string;
  /** customer id */
  customerId: string;
}

export interface WebResultCheckResultResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultCheckResultResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultAssetsBadgeResponseAllOfObj {
  rows?: AssetsBadgeResponse[];
}

export interface WebResultBadgesHoldersResponseAllOfObj {
  /** @format int64 */
  total?: number;
  list?: BadgesHolderResponse[];
}

/** 每个钱包地址对应的NFT持有信息 */
export interface WalletNftHolding {
  /** NFT持有项列表 */
  holdings: NftHoldingItem[];
  /** 钱包地址 */
  walletAddress: string;
}

export interface WebResultTokenBalancesResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultTokenBalancesResponseAllOfObj;
  msgKey?: string;
}

/** NFT合约列表 */
export interface NftHoldingDurationSummaryRequestNftContractsInner {
  /**
   * 链ID
   * @format int32
   */
  chainId: number;
  /** NFT合约地址 */
  contractAddress: string;
}

export interface WebResultNotificationsResponseAllOfObj {
  /** 分页信息 */
  pagination?: WebResultNotificationsResponseAllOfObjPagination;
  /**
   * 未读通知数量
   * @format int32
   * @example 3
   */
  unreadCount?: number;
  /** 用户的团队通知列表 */
  notifications?: WebResultNotificationsResponseAllOfObjNotifications[];
}

export interface MintResponseAllOfObj {
  rows?: MintRequest[];
}

/** Badge claim signatures */
export interface WebResultBadgeClaimSignatureResponseAllOfObj {
  /** List of claim signatures */
  signatures?: WebResultBadgeClaimSignatureResponseAllOfObjSignatures[];
}

export interface WebResultMemberRankingResponseAllOfObjPaginationSummaryTopContributor {
  /** User name of the top contributor */
  userName?: string;
  /** user id */
  userId?: string;
  /**
   * Total honor score of the top contributor
   * @format int32
   */
  totalHonorScore?: number;
}

/** 申请列表 */
export interface TeamApplicationItem {
  /**
   * 战队名称
   * @example "Awesome Team"
   */
  teamName?: string;
  /**
   * 过期天数
   * @format int32
   * @example 7
   */
  expireDays?: number;
  /**
   * 邀请人用户ID
   * @example "user_inviter456"
   */
  inviterId?: string;
  /**
   * 申请创建时间（UTC毫秒）
   * @format int64
   * @example 1672531200000
   */
  created?: number;
  /**
   * 战队ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 状态变更时间（UTC毫秒）
   * @format int64
   * @example 1672617600000
   */
  modified?: number;
  /**
   * 申请ID
   * @example "app_1234567890"
   */
  id?: string;
  /**
   * 申请人用户名
   * @example "John Doe"
   */
  userName?: string;
  /**
   * 申请人用户ID
   * @example "user_9876543210"
   */
  userId?: string;
  /** 社媒信息（申请人的社媒信息，用于审核时参考） */
  socialMediaInfo?: TeamApplicationItemSocialMediaInfo;
  /**
   * 邀请人用户名
   * @example "Inviter Name"
   */
  inviterName?: string;
  /**
   * 申请状态：PENDING(待审核)/APPROVED(已通过)/DENIED(已拒绝)/CANCELLED(已取消)/EXPIRED(已过期)/TEAM_DISBANDED(战队解散）
   * @example "PENDING"
   */
  status?:
    | "PENDING"
    | "APPROVED"
    | "DENIED"
    | "CANCELLED"
    | "EXPIRED"
    | "TEAM_DISBANDED";
}

export interface WebResultMemberProfileResponseAllOfObjRanking {
  /**
   * 如果用户未加入团队，此字段为null
   * @format int32
   * @example 45
   */
  totalMembers?: number;
  /**
   * 如果用户未加入团队，此字段为null
   * @format int32
   * @example 1
   */
  currentUserRank?: number;
}

export interface WebResultListSeasonConfigVO {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultListSeasonConfigVOAllOfObj;
  msgKey?: string;
}

export interface WebResultBadgeResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultBadgeResponseAllOfObj;
  msgKey?: string;
}

export interface TokenBalancesRequest {
  /** 链标识符（例如："ethereum", "solana", "polygon", "bsc"） */
  chain_id: string;
  /** 钱包地址列表 */
  wallets: string[];
  /** 代币合约地址 */
  token_address: string;
}

export interface WebResultWalletDexPairStatesResponseAllOfObj {
  /** 是否调用成功（来自远端服务） */
  success?: boolean;
  /** 钱包在各链、各DEX交易对上的汇总状态 */
  pairStates?: WebResultWalletDexPairStatesResponseAllOfObjPairStates[];
  /** 远端服务返回消息 */
  message?: string;
}

export interface NftHoldingByDurationRequest {
  /**
   * 最小持有时间戳（毫秒），持有开始时间必须早于或等于此时间戳
   * @format int64
   */
  minHoldingTimestamp: number;
  /** 是否需要查询tokenId */
  queryTokenId?: boolean;
  /** 钱包地址列表 */
  walletAddresses: string[];
  /** NFT信息列表 */
  nftInfos: NftHoldingByDurationRequestNftInfosInner[];
}

export interface TeamLeaveResponse {
  /** 离开时间 */
  leftAt?: string;
  /**
   * 冷静期结束时间
   * @format int64
   */
  coolingPeriodEnd?: number;
  /** 团队id */
  teamId?: string;
  /** 是否在冷静期内 */
  coolingPeriodApplied?: boolean;
  /** 用户id */
  userId?: string;
}

export interface WebResultGrantBadgeRequestVO {
  signature?: string;
  week_id?: number;
  level_id?: number;
  season_id?: number;
  customer_id?: string;
  business_id?: string;
}

export interface WebResultUpdateSocialPrivacyResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultUpdateSocialPrivacyResponseAllOfObj;
  msgKey?: string;
}

export interface SeasonLevelConfigVO {
  /**
   * season level jump point
   * @format int64
   */
  jumpPoint?: number;
  /** season level name */
  name?: string;
  /** season level icon */
  icon?: string;
  /** season level share image */
  shareImage?: string;
  /**
   * season level slide rank
   * @format int64
   */
  slideRank?: number;
  /**
   * season level id
   * @format int64
   */
  id?: number;
  /**
   * season level jump rank
   * @format int64
   */
  jumpRank?: number;
  /** season level desc */
  desc?: string;
}

export interface WebResultMemberProfileResponseAllOfObj {
  /**
   * 社媒信息权限 public 完全公开 /teamOnly 团队内可见 /private 完全私密
   * @example "teamOnly"
   */
  socialPrivacy?: string;
  /**
   * 如果用户未加入团队，此字段为null
   * @example "CAPTAIN"
   */
  role?: string;
  /**
   * 用户退出团队后的冷却期结束时间，单位为毫秒时间戳。如果不在冷却期内，此字段为null
   * @format int64
   */
  coolingPeriodEnd?: number;
  scores?: WebResultMemberProfileResponseAllOfObjScores;
  /**
   * 如果用户未加入团队，此字段为null
   * @format int64
   * @example 1672531200000
   */
  joinedAt?: number;
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /** 如果用户未加入团队，此字段为null */
  invitedByUserId?: string;
  ranking?: WebResultMemberProfileResponseAllOfObjRanking;
  /**
   * 用户名称
   * @example "team_1234567890"
   */
  userName?: string;
  /**
   * 用户唯一ID
   * @example "team_1234567890"
   */
  userId?: string;
  socialMediaInfo?: SocialMediaInfo;
}

/** 分页信息 */
export interface WebResultNotificationsResponseAllOfObjPagination {
  /**
   * 总页数
   * @format int32
   * @example 1
   */
  totalPages?: number;
  /**
   * 每页记录数
   * @format int32
   * @example 20
   */
  pageSize?: number;
  /**
   * 当前页码
   * @format int32
   * @example 1
   */
  currentPage?: number;
  /**
   * 总记录数
   * @format int32
   * @example 15
   */
  totalCount?: number;
}

export interface WebResultNftHoldingDurationSummaryResponseAllOfObj {
  /** 远端服务返回码 */
  code?: string;
  /** 是否调用成功（来自远端服务） */
  success?: boolean;
  /** 远端服务返回消息 */
  message?: string;
  /** 每个合约在各链上的NFT持有时长汇总结果 */
  results?: WebResultNftHoldingDurationSummaryResponseAllOfObjResults[];
}

export interface WebResultJoinTeamResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: TeamVO;
  msgKey?: string;
}

export interface BadgeCategoryCompositeVO {
  /** all badges by category */
  tokens?: BadgeCategoryVO[];
}

export interface WebResultBadgeContributorsResponseAllOfObj {
  /** 贡献总结信息 */
  summary?: WebResultBadgeContributorsResponseAllOfObjSummary;
  /**
   * 团队徽章ID
   * @example "team_badge_A_4"
   */
  badgeId?: string;
  /**
   * 团队徽章名称
   * @example "团队徽章A-4"
   */
  badgeName?: string;
  /** 贡献者列表 */
  contributors?: TeamContributorItem[];
}

/** 个人所属团队信息及徽章详情 */
export interface WebResultTeamLeaderboardResponseAllOfObjPersonalTeamInfo {
  /**
   * 个人所属团队排名
   * @format int32
   */
  teamRank?: number;
  /** 个人在该团队中的徽章详情列表 */
  badgeDetails?: WebResultTeamLeaderboardResponseAllOfObjPersonalTeamInfoBadgeDetails[];
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 个人所属团队总荣誉分
   * @format int32
   */
  totalHonorScore?: number;
}

export interface WebResultUserInfoResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultUserInfoResponseAllOfObj;
  msgKey?: string;
}

export interface BadgeSingleCheckRequest {
  /** Customer wallet address */
  customerAddress: string;
}

export interface WebResultNftHoldingByDurationResponseAllOfObj {
  /** 每个钱包地址对应的NFT持有信息 */
  results?: WalletNftHolding[];
}

/** 用户的团队通知列表 */
export interface WebResultNotificationsResponseAllOfObjNotifications {
  /**
   * 创建时间（UTC毫秒）
   * @format int64
   * @example 1672531200000
   */
  createdAt?: number;
  /** 解锁的徽章列表（仅在type为BADGE_UNLOCKED时返回） */
  unlockedBadges?: BadgeVO[];
  /**
   * 通知附加数据
   * @example "{badgeId=badge_123, badgeName=Achiever}"
   */
  data?: object;
  /**
   * 团队ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 通知ID
   * @example "notif_1234567890"
   */
  notificationId?: string;
  /**
   * 通知类型：BADGE_UNLOCKED, CAPTAIN_SUCCESSOR, MEMBER_KICKED
   * @example "BADGE_UNLOCKED"
   */
  type?: string;
  /**
   * 通知标题
   * @example "徽章解锁通知"
   */
  title?: string;
  /**
   * 过期时间（UTC毫秒）
   * @format int64
   * @example 1704067200000
   */
  expireAt?: number;
  /**
   * 用户ID
   * @example "user_1234567890"
   */
  userId?: string;
  /**
   * 通知内容详情
   * @example "恭喜你解锁了新的徽章！"
   */
  content?: string;
}

/** condition progress */
export interface ProgressDTO {
  /** condition name */
  name?: string;
  /** progress value */
  value?: string;
}

export interface BadgeClaimSignatureRequest {
  /** Customer wallet address */
  customerAddress: string;
  /** List of badge IDs to claim */
  badgeIds: string[];
}

export interface WebResultTransactionHashProcess {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: boolean;
  msgKey?: string;
}

/** all badges by category */
export interface BadgeCategoryVO {
  /** max level in category token list */
  maxLevel?: string;
  /** token status(LIVE, OFFLINE, COMING) */
  tokenStatus?: string;
  /**
   * minted Count
   * @format int64
   */
  mintedCount?: number;
  /** claimable id */
  claimableId?: string;
  /** badge type */
  type?: string;
  /** price */
  price?: string;
  /** badge gateway logo */
  logo?: string;
  /** every badge status of category (0: pending, 1: claimable, 2: claimed) */
  categoryStatuses?: string;
  /**
   * reward
   * @format int32
   */
  reward?: number;
  /** badge contract address */
  address?: string;
  /** badge token id */
  tokenId?: string;
  /** level */
  level?: string;
  /**
   * total supply
   * @format int64
   */
  totalSupply?: number;
  /**
   * token sort
   * @format int32
   */
  sort?: number;
  /**
   * badge claimed time
   * @format int64
   */
  claimTime?: number;
  /** currency */
  token?: string;
  /** badge condition list */
  condition?: Condition[];
  /** badge series type */
  series?: string;
  /**
   * badge count of category
   * @format int32
   */
  categoryTokenCount?: number;
  /** badge name */
  name?: string;
  /** category */
  category?: string;
  /** business type */
  businessType?: string;
  /** badge desc */
  desc?: string;
  /** badge status(pending、claimable、claimed) */
  status?: string;
  /** badge rarity */
  rarity?: string;
}

export interface CheckEventRequest {
  /** series */
  series: string;
  /** customer id */
  customerId: string;
  /** condition progress */
  progress: ProgressDTO[];
}

export interface WebResultBadgeCategoryResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: BadgeCategoryCompositeVO;
  msgKey?: string;
}

/** 社媒信息（申请人的社媒信息，用于审核时参考） */
export interface TeamApplicationItemSocialMediaInfo {
  /**
   * X（原Twitter）账号
   * @example "@username"
   */
  xHandle?: string;
  /**
   * Discord 账号
   * @example "username#1234"
   */
  discordHandle?: string;
  /**
   * Telegram 账号
   * @example "@username"
   */
  telegramHandle?: string;
}

export interface WebResultBadgeCheckResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  /** Badge check result */
  obj?: WebResultBadgeCheckResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultNftHoldingDurationSummaryResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultNftHoldingDurationSummaryResponseAllOfObj;
  msgKey?: string;
}

export interface NftHoldingDurationSummaryRequest {
  /** 用户钱包地址列表 */
  walletAddresses: string[];
  /** NFT合约列表 */
  nftContracts: NftHoldingDurationSummaryRequestNftContractsInner[];
}

export interface WebResultNftSeriesDetailResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: NftSeriesDetailVO;
  msgKey?: string;
}

export interface QueryAssetsRequest {
  /**
   * limit(max: 200)
   * @format int32
   */
  limit?: number;
  /** customer ids */
  customerIds: string[];
  /** query strategy(ALL: return all record, MAX: return max record, REWARD: order by reward desc) */
  strategy: "ALL" | "MAX" | "REWARD";
  /** status(pending、claimable、claimed) */
  status: string;
  /** status(N、R、SR、SSR) */
  rarity?: string;
}

export interface DocPagination {
  /** 下页token */
  nextToken?: string;
  /**
   * 每次请求数
   * @format int32
   * @min 1
   * @max 20
   */
  limit?: number;
  /**
   * 返回的总页数，默认不查询总页数，返回0
   * @format int64
   */
  totalCount?: number;
  rows?: DocPaginationRowsInner[];
}

export interface WebResultTokenBalancesResponseAllOfObj {
  /** 每个钱包地址对应的代币余额信息 */
  balances?: TokenBalanceInfo[];
}

/** 每个合约在各链上的NFT持有时长汇总结果 */
export interface WebResultNftHoldingDurationSummaryResponseAllOfObjResults {
  /** 持有时长列表（毫秒，倒序排列） */
  holdTimes?: number[];
  /**
   * 链ID
   * @format int32
   */
  chainId?: number;
  /** NFT合约地址 */
  contractAddress?: string;
}

export interface WebResultBadgeSeriesDetailResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: BadgeSeriesCompositeVO;
  msgKey?: string;
}

export interface UserOpHashProcessRequest {
  /** 合约调用成功后返回的：userOpsHash */
  userOperationHash: string;
  /** 处理类型 */
  processType?: "ERC20_TRANSFER";
}

/** 徽章总结信息 */
export interface WebResultTeamBadgesResponseAllOfObjSummary {
  /**
   * 总徽章数量
   * @format int32
   */
  totalBadges?: number;
  /**
   * 已解锁徽章数量
   * @format int32
   */
  unlockedBadges?: number;
  /**
   * 总体解锁进度（0.0 - 1.0）
   * @format float
   */
  unlockProgress?: number;
  /**
   * 总荣誉积分
   * @format int32
   */
  totalHonorScore?: number;
}

export interface WebResultTeamLeaderboardResponseAllOfObj {
  /** 团队排行榜列表 */
  leaderboard?: TeamRankingItem[];
  /** 分页信息 */
  pagination?: WebResultTeamLeaderboardResponseAllOfObjPagination;
  /** 个人所属团队信息及徽章详情 */
  personalTeamInfo?: WebResultTeamLeaderboardResponseAllOfObjPersonalTeamInfo;
}

export interface WebResultNftSeriesResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: NftSeriesDetailVO[];
  msgKey?: string;
}

export interface WebResultBadgesCheckResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  msgKey?: string;
}

export interface WebResultListSeasonConfigVOAllOfObj {
  rows?: SeasonConfigVO[];
}

export interface BadgeSeriesCompositeVO {
  /** series ext */
  ext?: string;
  /**
   * total reward
   * @format int32
   */
  rewardTotal?: number;
  /** all badges in series */
  nfts?: BadgeVO[];
  /** series type */
  series?: string;
  /** series name */
  name?: string;
  /** series gateway logo */
  logo?: string;
  /** series detail */
  detail?: string;
  /**
   * series sort
   * @format int32
   */
  sort?: number;
  /** series type, unique key */
  type?: string;
  businessType?: string[];
  /** series group */
  group?: string;
  /** series desc */
  desc?: string;
}

/** Badge assets data */
export interface WebResultBadgeAssetsResponseAllOfObj {
  /**
   * Total number of items
   * @format int64
   */
  total?: number;
  /** Next page token */
  nextToken?: string;
  /** List of user badge assets */
  rows?: BadgeVO[];
}

export interface WebResultBadgeDetailResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  /** 团队徽章对应的个人徽章详情列表 */
  obj?: BadgeVO;
  msgKey?: string;
}

export interface SeasonConfigVO {
  name?: string;
  levelConfig?: SeasonLevelConfigVO[];
  /**
   * season id
   * @format int64
   */
  id?: number;
  /**
   * season begin time
   * @format int64
   */
  beginTime?: number;
  /**
   * season end time
   * @format int64
   */
  endTime?: number;
}

export interface BadgeCheckRequest {
  /** Wallet type (ALL, EVM, SOLANA) */
  walletType?: string;
  /** badge groups */
  groups?: string[];
}

export interface NftSeriesDetailVO {
  /** series ext */
  ext?: string;
  /**
   * total reward
   * @format int32
   */
  rewardTotal?: number;
  /** all nfts in series */
  nfts?: NftVO[];
  /** series type */
  series?: string;
  /** series name */
  name?: string;
  /** series gateway logo */
  logo?: string;
  /** series detail */
  detail?: string;
  /**
   * series sort
   * @format int32
   */
  sort?: number;
  /** series type, unique key */
  type?: string;
  /** series group */
  group?: string;
  /** series desc */
  desc?: string;
}

export interface MintResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: MintResponseAllOfObj;
  msgKey?: string;
}

export interface BadgesCheckRequest {
  /**
   * amount, 上限 500
   * @format int32
   */
  amount?: number;
  /** token id */
  tokenId?: string;
  /** series */
  series: string;
  /** customer id */
  customerId: string;
  /** biz id */
  bizId: string;
  /** 条件的完成进度，非必填，默认为设置的目标值 */
  progress?: ProgressDTO[];
}

export interface ImprintVO {
  /** user state */
  userState?: string;
  /** ext user id */
  extUserId?: string;
  /**
   * last detect time
   * @format int64
   */
  lastDetectTime?: number;
  /** anchor user id */
  userId?: string;
}

export interface WebResultMemberRankingResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultMemberRankingResponseAllOfObj;
  msgKey?: string;
}

export interface WebResultGrantBadgeResponseVOAllOfObj {
  result?: boolean;
}

export interface WebResultNftHoldingByDurationResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultNftHoldingByDurationResponseAllOfObj;
  msgKey?: string;
}

export interface WalletDexPairStatesRequest {
  /** 交易对地址（流动性池合约地址），如果同时提供 baseTokenAddress 和 quoteTokenAddress，则该字段会被忽略 */
  pairAddress?: string;
  /** 链标识（例如 ethereum、solana、polygon、bsc） */
  chainId: string;
  /** 报价代币地址（与 baseTokenAddress 一起提供时，将按代币对维度聚合） */
  quoteTokenAddress?: string;
  /** 基础代币地址（与 quoteTokenAddress 一起提供时，将按代币对维度聚合） */
  baseTokenAddress?: string;
  /** 要查询的钱包地址列表 */
  wallets: string[];
}

/** 个人在该团队中的徽章详情列表 */
export interface WebResultTeamLeaderboardResponseAllOfObjPersonalTeamInfoBadgeDetails {
  /** 徽章ID */
  badgeId?: string;
  /** 徽章名称 */
  badgeName?: string;
  /**
   * 徽章等级
   * @format int32
   */
  level?: number;
  /**
   * 徽章进度百分比
   * @format int32
   */
  progress?: number;
  /** 徽章描述 */
  description?: string;
  /** 徽章图片URL */
  badgeImage?: string;
}

/** List of claim signatures */
export interface WebResultBadgeClaimSignatureResponseAllOfObjSignatures {
  /** Unique identifier */
  uid?: string;
  /**
   * Quantity to mint
   * @format int64
   */
  quantity?: number;
  /** Badge identifier */
  badgeId?: string;
  /** Claim signature */
  signature?: string;
  /** Chain identifier */
  chainId?: string;
  /** Price */
  price?: string;
  /** Contract address */
  contractAddress?: string;
  /** Currency */
  currency?: string;
  /**
   * Signature validity end time
   * @format int64
   */
  validityEndTimestamp?: number;
  /** Request identifier */
  id?: string;
  /**
   * Signature validity start time
   * @format int64
   */
  validityStartTimestamp?: number;
  /** Project handle */
  projectHandle?: string;
}

/** 贡献者列表 */
export interface TeamContributorItem {
  /**
   * 贡献类型
   * @example "BADGE_HOLDER"
   */
  contributionType?: string;
  /**
   * 用户头像URL
   * @example "https://example.com/user-avatar-1.jpg"
   */
  avatarUrl?: string;
  /** ext user id */
  extUserId?: string;
  /**
   * 贡献值
   * @format int32
   * @example 1
   */
  contributionValue?: number;
  /**
   * 贡献描述
   * @example "持有个人徽章001"
   */
  contributionDescription?: string;
  /**
   * 用户名
   * @example "Captain"
   */
  userName?: string;
  /** user id */
  userId?: string;
}

export interface WebResultTeamApplicationsResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultTeamApplicationsResponseAllOfObj;
  msgKey?: string;
}

export interface NFTMintRequestVO {
  /** customer address */
  customerAddress?: string;
  /** nft type */
  nftType?: "badge";
  /** nft address */
  contractAddress?: string;
  /** claimable ids */
  claimableIds?: string[];
}

export interface SocialMediaInfo {
  /**
   * X（原Twitter）账号
   * @example "user_x_handle"
   */
  xHandle?: string;
  /**
   * Discord 账号
   * @example "user#1234"
   */
  discordHandle?: string;
  /**
   * Telegram 账号
   * @example "@user_telegram"
   */
  telegramHandle?: string;
}

export interface WebResultBadgeVerifiersResponse {
  /**
   * Response code
   * @example "0000"
   */
  code?: string;
  /** Badge condition configuration result */
  data?: WebResultBadgeConditionConfigResponseData;
  /**
   * Response message
   * @example "success"
   */
  message?: string;
}

export interface DocMultiplePaginationResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: DocPagination;
  msgKey?: string;
}

export interface WebResultAssetsBadgeResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultAssetsBadgeResponseAllOfObj;
  msgKey?: string;
}

/** badge condition list */
export interface Condition {
  /** condition target id */
  targetId?: string;
  /** condition scope */
  scope: string;
  /** condition name */
  name: string;
  /** condition achieved */
  achieved?: string;
  /** condition threshold */
  threshold?: string;
  /** condition type */
  type: string;
  /** condition target */
  target: string;
  /** verify status */
  status?: string;
}

export interface WebResultTeamBadgesResponseAllOfObj {
  /** 团队徽章列表 */
  badges?: TeamBadgeItem[];
  /** 徽章总结信息 */
  summary?: WebResultTeamBadgesResponseAllOfObjSummary;
}

export interface TeamVO {
  /**
   * 团队名称
   * @example "Awesome Team"
   */
  teamName?: string;
  /**
   * 团队最大成员数量
   * @format int32
   * @example 50
   */
  maxMemberCount?: number;
  /**
   * 团队头像地址
   * @example "https://example.com/avatar.png"
   */
  avatarUrl?: string;
  /**
   * 团队背景图地址
   * @example "https://example.com/background.png"
   */
  backgroundImage?: string;
  /**
   * 团队成员数量
   * @format int32
   * @example 42
   */
  memberCount?: number;
  /**
   * 团队描述
   * @example "This is an awesome team."
   */
  description?: string;
  /**
   * 创建时间（UTC毫秒）
   * @format int64
   * @example 1672531200000
   */
  createdAt?: number;
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 团队荣誉分（用于排行榜）
   * @format int32
   * @example 1500
   */
  honorScore?: number;
  /**
   * 团队类型（public/private/invite_only）
   * @example "public"
   */
  teamType?: string;
  /**
   * 队长用户ID
   * @example "user_9876543210"
   */
  captainUserId?: string;
  /**
   * 团队总荣誉分
   * @format int32
   * @example 5000
   */
  totalHonorScore?: number;
  /**
   * 团队状态（active/inactive/deleted）
   * @example "active"
   */
  status?: string;
  /**
   * 更新时间（UTC毫秒）
   * @format int64
   * @example 1672617600000
   */
  updatedAt?: number;
}

export interface WebResultUserInfoResponseAllOfObj {
  user?: UserInfoVO;
}

export interface WebResultMemberRankingResponseAllOfObjPagination {
  summary?: WebResultMemberRankingResponseAllOfObjPaginationSummary;
  /**
   * Total number of pages
   * @format int32
   */
  totalPages?: number;
  /**
   * Number of items per page
   * @format int32
   */
  pageSize?: number;
  /**
   * Current page number
   * @format int32
   */
  currentPage?: number;
  /**
   * Total number of items
   * @format int64
   */
  totalCount?: number;
}

export interface BatchMintRequestVO {
  /** customer address */
  customerAddress: string;
  /** nft address */
  contractAddress: string;
  /** token ids */
  tokenIds: string[];
}

/** 团队徽章对应的个人徽章详情列表 */
export interface BadgeVO {
  /** token status(LIVE, OFFLINE, COMING) */
  tokenStatus?: string;
  /**
   * minted Count
   * @format int64
   */
  mintedCount?: number;
  /** badge series logo */
  seriesLogo?: string;
  /** claimable id */
  claimableId?: string;
  /** badge type */
  type?: string;
  /**
   * badge tier
   * @format int32
   */
  tier?: number;
  /** price */
  price?: string;
  /** badge gateway logo */
  logo?: string;
  /**
   * reward
   * @format int32
   */
  reward?: number;
  /** show new tag */
  newTag?: boolean;
  /** badge complete process */
  process?: number;
  /** badge contract address */
  address?: string;
  /** badge token id */
  tokenId?: string;
  /** level */
  level?: string;
  /** badge series name */
  seriesName?: string;
  /**
   * total supply
   * @format int64
   */
  totalSupply?: number;
  /**
   * token sort
   * @format int32
   */
  sort?: number;
  /** badge condition max */
  maxCond?: number;
  /**
   * badge claimed time
   * @format int64
   */
  claimTime?: number;
  /** currency */
  token?: string;
  /** badge condition list */
  condition?: Condition[];
  /** badge series type */
  series?: string;
  /** badge condition min */
  minCond?: number;
  /** badge name */
  name?: string;
  /** badge conditions and progress */
  progress?: BadgeProgressVO[];
  /** category */
  category?: string;
  /** business type */
  businessType?: string;
  /** badge desc */
  desc?: string;
  /** badge status(pending、claimable、claimed) */
  status?: string;
  /** badge rarity */
  rarity?: string;
}

export interface WebResultTeamDetailResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultTeamDetailResponseAllOfObj;
  msgKey?: string;
}

/** badge conditions and progress */
export interface BadgeProgressVO {
  /** condition number */
  condition?: string;
  /** condition name */
  name?: string;
  /** condition type */
  type?: string;
  /** progress value */
  value?: string;
}

/** 贡献总结信息 */
export interface WebResultBadgeContributorsResponseAllOfObjSummary {
  /**
   * 是否参与了解锁徽章
   * @example true
   */
  participateContributions?: boolean;
  /**
   * 当前贡献进度（0.0 - 1.0）
   * @format float
   * @example 1
   */
  contributionProgress?: number;
  /**
   * 总贡献者数量
   * @format int32
   * @example 15
   */
  totalContributors?: number;
  /**
   * 解锁所需贡献者数量
   * @format int32
   * @example 10
   */
  requiredContributors?: number;
}

/** Badge condition configuration result */
export interface WebResultBadgeConditionConfigResponseData {
  /**
   * Next verification time in milliseconds
   * @format int64
   */
  nextVerifyTime?: number;
  /** Configuration as JSON string */
  config?: string;
}

export interface WebResultBadgeCategoryDetailResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: BadgeCategoryCompositeVO;
  msgKey?: string;
}

export interface WebResultMemberRankingResponseAllOfObjPaginationSummary {
  /**
   * Total number of team members
   * @format int32
   */
  totalMembers?: number;
  /**
   * Average honor score of team members
   * @format int32
   */
  averageHonorScore?: number;
  topContributor?: WebResultMemberRankingResponseAllOfObjPaginationSummaryTopContributor;
}

/** 团队排行榜列表 */
export interface TeamRankingItem {
  /** 团队名称 */
  teamName?: string;
  /** 社媒信息权限 public 完全公开 /teamOnly 团队内可见 /private 完全私密 */
  socialPrivacy?: string;
  /** 团队已解锁的徽章列表 */
  unlockedBadges?: TeamRankingItemUnlockedBadgesInner[];
  /** 队长用户名 */
  captainUserName?: string;
  /** 团队头像URL */
  avatarUrl?: string;
  /** 团队背景图片URL */
  backgroundImage?: string;
  /**
   * 团队成员数量
   * @format int32
   */
  memberCount?: number;
  /** 团队描述 */
  description?: string;
  socialMediaInfo?: SocialMediaInfo;
  /**
   * 团队创建时间（时间戳）
   * @format int64
   */
  createdAt?: number;
  /**
   * 团队总成员数量上限
   * @format int32
   */
  maxMembers?: number;
  /**
   * 团队唯一ID
   * @example "team_1234567890"
   */
  teamId?: string;
  /**
   * 团队排名
   * @format int32
   */
  rank?: number;
  /** 团队类型（如公开、私密） */
  teamType?: string;
  /** 队长用户ID */
  captainUserId?: string;
  /**
   * 团队总荣誉分
   * @format int32
   */
  totalHonorScore?: number;
}

export interface WebResultTeamBadgesResponse {
  responseEnum?:
    | "SUCCESS"
    | "SYSTEM_VERIFY_CLOSE"
    | "SYSTEM_VERIFY_OPEN_AND_OK"
    | "SYSTEM_VERIFY_OPEN_NEED_PHONE"
    | "SIGNATURE_ERROR"
    | "CUSTOMER_LOGIN_REQUIRED"
    | "CUSTOMER_NEW_LOGIN"
    | "CUSTOMER_MAIL_CODE_REQUIRED"
    | "CUSTOMER_MAIL_DUPLICATE"
    | "CUSTOMER_MAIL_CODE_INCORRECT"
    | "CUSTOMER_REFERENCE_REQUIRED"
    | "CUSTOMER_API_INVALID_SIGNATURE"
    | "CUSTOMER_PHONE_BIND_SUCCESS"
    | "CUSTOMER_LOGIN_PARAMETER_INCORRECT"
    | "CUSTOMER_LOGIN_INCORRECT"
    | "USER_NOT_EXIST"
    | "SYSTEM_OPERATION_FREQUENT"
    | "SYSTEM_SECURITY_PARAM_REQUIRED"
    | "SYSTEM_SECURITY_CHECK_FAIL"
    | "SYSTEM_PARAMETER_INVALID"
    | "SYSTEM_PARAMETER_REQUIRED"
    | "SYSTEM_PARAMETER_FORMAT_INCORRECT"
    | "SYSTEM_PARAMETER_TYPE_MISMATCH"
    | "SYSTEM_PARAMETER_NEED_DIGITAL"
    | "SYSTEM_DATA_NOT_FOUND"
    | "SYSTEM_CACHE_REFRESH_FAIL"
    | "SYSTEM_ACCESS_INTERFACE_OFFLINE"
    | "SYSTEM_UPGRADE_VERSION"
    | "SYSTEM_ACCESS_RESTRICTED"
    | "SYSTEM_HEADER_SAAS_ID_REQUIRED"
    | "SYSTEM_HEADER_CHAIN_ID_REQUIRED"
    | "SYSTEM_HEADER_JWT_TOKEN_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_ID_REQUIRED"
    | "SYSTEM_HEADER_DEVICE_TYPE_REQUIRED"
    | "SYSTEM_HEADER_VERSION_REQUIRED"
    | "API_RATE_LIMITING"
    | "SYSTEM_PROJECT_NOT_FOUND"
    | "SYSTEM_HEADER_PROJECT_ID_REQUIRED"
    | "PARAMS_JWT_DECRYPT_FAIL"
    | "PARAMS_JWT_CHECK_INVALID"
    | "SYSTEM_CONFIG_ERROR"
    | "SYSTEM_UNAVAILABLE"
    | "SYSTEM_ERROR"
    | "SYSTEM_UPGRADING";
  code?: string;
  success?: boolean;
  obj?: WebResultTeamBadgesResponseAllOfObj;
  msgKey?: string;
}

/** Pagination information */
export interface WebResultBadgeClaimableListResponseAllOfPagination {
  /**
   * Total number of items
   * @format int32
   */
  total?: number;
  /** Next page token */
  nextToken?: string;
}

export interface PurchaseRequest {
  /** tokenId */
  tokenId: string;
  /** customer id */
  customerId: string;
  /**
   * purchase discount
   * @format float
   */
  discount?: number;
  /** mint to address */
  toAddress: string;
}

export interface UserInfoVO {
  /** chain id */
  chainId?: string;
  /** ext user id */
  extUserId?: string;
  /** anchor user id */
  userId?: string;
  /** project id */
  projectId?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<
  D extends unknown,
  E extends unknown = unknown,
> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "https://anchordev.dipbit.xyz/";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const responseToParse = responseFormat ? response.clone() : response;
      const data = !responseFormat
        ? r
        : await responseToParse[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Anchor OpenApi
 * @version V1.0
 * @license Apache 2.0 (http://springdoc.org)
 * @baseUrl https://anchordev.dipbit.xyz/
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  v1 = {
    /**
     * @description Search multiple documents across different modules.
     *
     * @tags SearchV1
     * @name SearchMultiple
     * @summary search multiple
     * @request GET:/v1/search/multiple
     */
    searchMultiple: (
      query?: {
        /** search keyWords */
        keywords?: string;
        /** zone */
        zone?: string;
        /**
         * nextToken for pagination
         * @format int32
         */
        page?: number;
        /**
         * limit for pagination
         * @format int32
         */
        limit?: number;
        /** searchType List */
        types?: "TEAM"[];
        /** sort List */
        sort?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<DocMultiplePaginationResponse, any>({
        path: `/v1/search/multiple`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description anchor check
     *
     * @tags Anchor
     * @name Check
     * @summary anchor check
     * @request POST:/v1/check/{type}
     */
    check: (type: string, params: RequestParams = {}) =>
      this.request<WebResultCheckResponse, any>({
        path: `/v1/check/${type}`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description get check result
     *
     * @tags Anchor
     * @name GetCheckResult
     * @summary get check result
     * @request GET:/v1/check/{type}
     */
    getCheckResult: (type: string, params: RequestParams = {}) =>
      this.request<WebResultCheckResultResponse, any>({
        path: `/v1/check/${type}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 确认处理申请（如标记已读/已查看），不改变申请状态
     *
     * @tags TeamV1
     * @name AcknowledgeApplication
     * @summary Acknowledge application
     * @request POST:/v1/applications/{applicationId}/acknowledge
     */
    acknowledgeApplication: (
      applicationId: string,
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultApplicationActionResponse,
        WebResultApplicationActionResponse
      >({
        path: `/v1/applications/${applicationId}/acknowledge`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取团队内成员贡献排行榜
     *
     * @tags TeamV1
     * @name GetTeamMemberRanking
     * @summary Get team member ranking
     * @request GET:/v1/teams/{teamId}/members/ranking
     */
    getTeamMemberRanking: (
      teamId: string,
      query?: {
        /** @format int32 */
        page?: number;
        /** @format int32 */
        size?: number;
        type?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultMemberRankingResponse, any>({
        path: `/v1/teams/${teamId}/members/ranking`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 批准入队申请（队长权限）
     *
     * @tags TeamV1
     * @name ApproveApplication
     * @summary Approve application
     * @request POST:/v1/applications/{applicationId}/approve
     */
    approveApplication: (applicationId: string, params: RequestParams = {}) =>
      this.request<
        WebResultApplicationActionResponse,
        WebResultApplicationActionResponse
      >({
        path: `/v1/applications/${applicationId}/approve`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description 取消入队申请（用户取消自己的申请）
     *
     * @tags TeamV1
     * @name CancelApplication
     * @summary Cancel application
     * @request POST:/v1/applications/{applicationId}/cancel
     */
    cancelApplication: (applicationId: string, params: RequestParams = {}) =>
      this.request<
        WebResultApplicationActionResponse,
        WebResultApplicationActionResponse
      >({
        path: `/v1/applications/${applicationId}/cancel`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description get nft series by id
     *
     * @tags Anchor
     * @name GetNftSeriesById
     * @summary get nft series by id
     * @request GET:/v1/series/{type}/{series}
     */
    getNftSeriesById: (
      type: string,
      series: string,
      query?: {
        /** 用户id */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultNftSeriesDetailResponse, any>({
        path: `/v1/series/${type}/${series}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取团队排行榜，支持分页查询，返回个人团队信息
     *
     * @tags TeamV1
     * @name GetTeamLeaderboard
     * @summary Get team leaderboard
     * @request GET:/v1/teams/leaderboard
     */
    getTeamLeaderboard: (
      query?: {
        /** @format int32 */
        page?: number;
        /** @format int32 */
        size?: number;
        type?: string;
        /** 是否只返回可加入的团队（true: 只返回可加入的, false/不传: 返回所有） */
        joinable?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTeamLeaderboardResponse, any>({
        path: `/v1/teams/leaderboard`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取团队详情，包含已解锁的徽章信息
     *
     * @tags TeamV1
     * @name GetTeamDetail
     * @summary Get team detail
     * @request GET:/v1/teams/{teamId}/detail
     */
    getTeamDetail: (teamId: string, params: RequestParams = {}) =>
      this.request<WebResultTeamDetailResponse, any>({
        path: `/v1/teams/${teamId}/detail`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 标记指定通知为已读状态
     *
     * @tags TeamV1
     * @name MarkNotificationRead
     * @summary Mark notification as read
     * @request POST:/v1/notifications/{notificationId}/read
     */
    markNotificationRead: (
      notificationId: string,
      params: RequestParams = {},
    ) =>
      this.request<WebResultNotificationReadResponse, any>({
        path: `/v1/notifications/${notificationId}/read`,
        method: "POST",
        format: "json",
        ...params,
      }),

    /**
     * @description list season config
     *
     * @tags Season
     * @name ListSeasonConfig
     * @summary list season config
     * @request GET:/v1/seasons
     */
    listSeasonConfig: (params: RequestParams = {}) =>
      this.request<WebResultListSeasonConfigVO, any>({
        path: `/v1/seasons`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取指定徽章的贡献者列表
     *
     * @tags TeamV1
     * @name GetBadgeContributors
     * @summary Get badge contributors
     * @request GET:/v1/teams/badges/{badgeId}/contributors
     */
    getBadgeContributors: (badgeId: string, params: RequestParams = {}) =>
      this.request<WebResultBadgeContributorsResponse, any>({
        path: `/v1/teams/badges/${badgeId}/contributors`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description query user claimable or claimed Badges
     *
     * @tags Anchor
     * @name BadgeAssets
     * @summary query user claimable or claimed Badges
     * @request GET:/v1/badges
     */
    badgeAssets: (
      query?: {
        /** customer id */
        customerId?: string;
        /** nft status, values(claimable、claimed) */
        status?: string;
        /** 返回数据的策略(all：返回所有徽章, max：仅返回同系列等级最高的徽章, reward：按照reward倒序返回, time：按照时间倒序返回) */
        strategy?: string;
        /** badge series */
        series?: string;
        /**
         * 每页条数
         * @format int32
         */
        limit?: number;
        /** 分页参数 */
        nextToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultBadgeResponse, any>({
        path: `/v1/badges`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询当前用户的入队申请列表，支持分页
     *
     * @tags TeamV1
     * @name GetUserApplications
     * @summary Get user applications
     * @request GET:/v1/applications/me
     */
    getUserApplications: (
      query?: {
        /**
         * 页码，从1开始
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * 每页条数
         * @format int32
         * @default 20
         */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTeamApplicationsResponse, any>({
        path: `/v1/applications/me`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询战队的入队申请列表（队长权限），支持分页
     *
     * @tags TeamV1
     * @name GetTeamApplications
     * @summary Get team applications
     * @request GET:/v1/teams/{teamId}/applications
     */
    getTeamApplications: (
      teamId: string,
      query?: {
        /**
         * 页码，从1开始
         * @format int32
         * @default 1
         */
        page?: number;
        /**
         * 每页条数
         * @format int32
         * @default 20
         */
        size?: number;
        /** 申请状态过滤，可传多个状态，不传表示查询所有状态 */
        status?: string[];
        /**
         * 排序方式：CREATED_ASC(申请时间正序，先到先审)/MODIFIED_DESC(状态变更时间倒序，最新操作在前)
         * @default "CREATED_ASC"
         */
        sortOrder?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultTeamApplicationsResponse,
        WebResultTeamApplicationsResponse
      >({
        path: `/v1/teams/${teamId}/applications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 前端监听到合约成功事件，调用加快后端事件处理
     *
     * @tags Transaction
     * @name UserOpHashProcess
     * @summary userOpHash process
     * @request POST:/v1/transaction/process/userOpHash
     */
    userOpHashProcess: (
      data: UserOpHashProcessRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultUserOpHashProcess, any>({
        path: `/v1/transaction/process/userOpHash`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取团队所有徽章的状态信息，支持按状态筛选
     *
     * @tags TeamV1
     * @name GetTeamBadges
     * @summary Get team badges
     * @request GET:/v1/teams/badges
     */
    getTeamBadges: (
      query?: {
        category?: string;
        status?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTeamBadgesResponse, any>({
        path: `/v1/teams/badges`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description get nft series
     *
     * @tags Anchor
     * @name NftSeries
     * @summary get nft series
     * @request GET:/v1/series/{type}
     */
    nftSeries: (type: string, params: RequestParams = {}) =>
      this.request<WebResultNftSeriesResponse, any>({
        path: `/v1/series/${type}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 拒绝入队申请（队长权限）
     *
     * @tags TeamV1
     * @name DenyApplication
     * @summary Deny application
     * @request POST:/v1/applications/{applicationId}/deny
     */
    denyApplication: (
      applicationId: string,
      data: DenyApplicationRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultApplicationActionResponse,
        WebResultApplicationActionResponse
      >({
        path: `/v1/applications/${applicationId}/deny`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 获取当前用户的个人概况信息
     *
     * @tags TeamV1
     * @name GetMyTeamProfile
     * @summary Get my team profile
     * @request GET:/v1/teams/members/me
     */
    getMyTeamProfile: (params: RequestParams = {}) =>
      this.request<WebResultMemberProfileResponse, any>({
        path: `/v1/teams/members/me`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 获取用户的通知列表
     *
     * @tags TeamV1
     * @name GetNotifications
     * @summary Get notifications
     * @request GET:/v1/notifications
     */
    getNotifications: (
      query?: {
        teamId?: string;
        /** @format int32 */
        page?: number;
        /** @format int32 */
        size?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultNotificationsResponse, any>({
        path: `/v1/notifications`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 前端监听到合约成功事件，调用加快后端事件处理
     *
     * @tags Transaction
     * @name TransactionHashProcess
     * @summary speed up transaction
     * @request POST:/v1/transaction/process/{txHash}
     */
    transactionHashProcess: (txHash: string, params: RequestParams = {}) =>
      this.request<WebResultTransactionHashProcess, any>({
        path: `/v1/transaction/process/${txHash}`,
        method: "POST",
        format: "json",
        ...params,
      }),
  };
  s1 = {
    /**
     * @description 更新用户社媒隐私设置
     *
     * @tags AnchorS2S
     * @name UpdateSocialPrivacy
     * @summary Update social media privacy
     * @request PUT:/s1/teams/update/social-privacy
     */
    updateSocialPrivacy: (
      data: UpdateSocialPrivacyRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultUpdateSocialPrivacyResponse,
        WebResultUpdateSocialPrivacyResponse
      >({
        path: `/s1/teams/update/social-privacy`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 退出当前团队
     *
     * @tags AnchorS2S
     * @name LeaveTeam
     * @summary Leave team (self)
     * @request DELETE:/s1/teams/leave/{userId}
     */
    leaveTeam: (userId: string, params: RequestParams = {}) =>
      this.request<WebResultLeaveTeamResponse, any>({
        path: `/s1/teams/leave/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description 查询我的团队信息
     *
     * @tags AnchorS2S
     * @name TeamDetail
     * @summary query my team info
     * @request GET:/s1/teams/detail/{userId}
     */
    teamDetail: (userId: string, params: RequestParams = {}) =>
      this.request<WebResultTeamDetailResponse, any>({
        path: `/s1/teams/detail/${userId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description 加入团队，支持通过邀请码或直接指定团队ID
     *
     * @tags AnchorS2S
     * @name JoinTeam
     * @summary Join team
     * @request POST:/s1/teams/join
     */
    joinTeam: (data: object, params: RequestParams = {}) =>
      this.request<WebResultJoinTeamResponse, any>({
        path: `/s1/teams/join`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 队长移除团队成员
     *
     * @tags AnchorS2S
     * @name RemoveTeamMember
     * @summary Remove member by captain
     * @request DELETE:/s1/teams/remove/{captainUserId}/{userId}
     */
    removeTeamMember: (
      captainUserId: string,
      userId: string,
      params: RequestParams = {},
    ) =>
      this.request<WebResultRemoveMemberResponse, any>({
        path: `/s1/teams/remove/${captainUserId}/${userId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * @description grant badge
     *
     * @tags AnchorS2S
     * @name GrantBadge
     * @summary grant badge
     * @request POST:/s1/badges
     */
    grantBadge: (
      data: WebResultGrantBadgeRequestVO,
      params: RequestParams = {},
    ) =>
      this.request<WebResultGrantBadgeResponseVO, any>({
        path: `/s1/badges`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description purchase mint with signature
     *
     * @tags AnchorS2S
     * @name PurchaseMint
     * @summary purchase mint with signature
     * @request POST:/s1/purchase/{type}
     */
    purchaseMint: (
      type: string,
      data: PurchaseRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultPurchaseResponse, any>({
        path: `/s1/purchase/${type}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 队长更新团队类型
     *
     * @tags AnchorS2S
     * @name UpdateTeamType
     * @summary Update team type
     * @request POST:/s1/teams/update/type/{captainUserId}
     */
    updateTeamType: (
      captainUserId: string,
      query: {
        /** Target team type to update to */
        targetType: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultTeamDetailResponse, any>({
        path: `/s1/teams/update/type/${captainUserId}`,
        method: "POST",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 创建新团队，支持设置背景图
     *
     * @tags AnchorS2S
     * @name CreateTeam
     * @summary Create team
     * @request POST:/s1/teams
     */
    createTeam: (data: object, params: RequestParams = {}) =>
      this.request<WebResultCreateTeamResponse, any>({
        path: `/s1/teams`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description query badges holders
     *
     * @tags AnchorS2S
     * @name QueryBadgesHolders
     * @summary query badges holders
     * @request GET:/s1/badges/holders
     */
    queryBadgesHolders: (
      query: {
        /** tokenId */
        tokenId: string;
        /**
         * @format int32
         * @default 10
         */
        limit?: number;
        /**
         * @format int32
         * @default 0
         */
        offset?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultBadgesHoldersResponse, any>({
        path: `/s1/badges/holders`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询钱包地址列表在指定NFT合约上的持有时长汇总，透传调用 anchorInsightNft.GetUserNftHoldingDurationSummary
     *
     * @tags AnchorS2S
     * @name GetUserNftHoldingDurationSummary
     * @summary 查询NFT持有时长汇总
     * @request POST:/s1/nft/holding-duration-summary
     */
    getUserNftHoldingDurationSummary: (
      data: NftHoldingDurationSummaryRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultNftHoldingDurationSummaryResponse, any>({
        path: `/s1/nft/holding-duration-summary`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 批量查询多个钱包地址的代币余额，透传调用RemoteInsightTokenService.GetTokenBalances
     *
     * @tags AnchorS2S
     * @name GetTokenBalances
     * @summary 批量查询代币余额
     * @request POST:/s1/token/balances
     */
    getTokenBalances: (
      data: TokenBalancesRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultTokenBalancesResponse, any>({
        path: `/s1/token/balances`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description get nft series by id
     *
     * @tags AnchorS2S
     * @name GetNftSeriesDetail
     * @summary get nft series by id
     * @request GET:/s1/series/{type}/{series}
     */
    getNftSeriesDetail: (
      type: string,
      series: string,
      query?: {
        /** 用户id */
        customerId?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultNftSeriesDetailResponse, any>({
        path: `/s1/series/${type}/${series}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description 重制探测徽章冷却时间
     *
     * @tags AnchorS2S
     * @name IntervalReset
     * @summary interval reset
     * @request POST:/s1/interval/reset
     */
    intervalReset: (data: IntervalResetRequest, params: RequestParams = {}) =>
      this.request<WebResultIntervalResetResponse, any>({
        path: `/s1/interval/reset`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 更新战队信息（队长权限）
     *
     * @tags AnchorS2S
     * @name UpdateTeam
     * @summary Update team information
     * @request PUT:/s1/teams/update
     */
    updateTeam: (data: UpdateTeamRequest, params: RequestParams = {}) =>
      this.request<WebResultUpdateTeamResponse, WebResultUpdateTeamResponse>({
        path: `/s1/teams/update`,
        method: "PUT",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description assets of badge
     *
     * @tags AnchorS2S
     * @name QueryAssets
     * @summary assets of badge
     * @request POST:/s1/assets/{type}
     */
    queryAssets: (
      type: string,
      data: QueryAssetsRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultAssetsBadgeResponse, any>({
        path: `/s1/assets/${type}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 根据链、交易对或代币对，查询多个钱包在DEX交易对上的交易汇总状态，透传调用 anchorInsightToken.GetWalletDexPairStates
     *
     * @tags AnchorS2S
     * @name GetWalletDexPairStates
     * @summary 查询钱包在DEX交易对上的汇总状态
     * @request POST:/s1/token/dex-pair-states
     */
    getWalletDexPairStates: (
      data: WalletDexPairStatesRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultWalletDexPairStatesResponse, any>({
        path: `/s1/token/dex-pair-states`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description check by event
     *
     * @tags AnchorS2S
     * @name CheckByEvent
     * @summary check by event
     * @request POST:/s1/check/event
     */
    checkByEvent: (data: CheckEventRequest, params: RequestParams = {}) =>
      this.request<WebResultCheckEventResponse, any>({
        path: `/s1/check/event`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description 查询钱包地址列表对应的NFT持有数量（持有时间超过指定时间戳），透传调用RemoteNftService.GetUserNftHoldingByDuration
     *
     * @tags AnchorS2S
     * @name GetUserNftHoldingByDuration
     * @summary 查询NFT持有数量（按持有时长）
     * @request POST:/s1/nft/holding-by-duration
     */
    getUserNftHoldingByDuration: (
      data: NftHoldingByDurationRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultNftHoldingByDurationResponse, any>({
        path: `/s1/nft/holding-by-duration`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description badges check
     *
     * @tags AnchorS2S
     * @name BadgesCheck
     * @summary badges check
     * @request POST:/s1/badges/check
     */
    badgesCheck: (data: BadgesCheckRequest, params: RequestParams = {}) =>
      this.request<WebResultBadgesCheckResponse, any>({
        path: `/s1/badges/check`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
  v2 = {
    /**
     * @description Get badges that the user can claim
     *
     * @tags BadgeV2
     * @name GetUserClaimableBadges
     * @summary Get user claimable badges
     * @request GET:/v2/badges/claimable
     */
    getUserClaimableBadges: (
      query?: {
        /** Badge series filter */
        series?: string;
        /** Badge token IDs filter */
        tokenIds?: string[];
        /**
         * Number of items per page
         * @format int32
         */
        limit?: number;
        /** Pagination token */
        nextToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeClaimableListResponse,
        WebResultBadgeClaimableListResponse
      >({
        path: `/v2/badges/claimable`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Query badge by category
     *
     * @tags BadgeV2
     * @name CategoriesList
     * @summary Query badge by category
     * @request GET:/v2/badges/categories
     */
    categoriesList: (
      query?: {
        /** include badges series */
        series?: string;
        /** include badges status */
        status?: string;
        /** include badges business type */
        businessType?: string;
        /** include badges categories */
        categories?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeCategoryResponse,
        WebResultBadgeCategoryResponse
      >({
        path: `/v2/badges/categories`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get verifiers for badge conditions based on platform and type
     *
     * @tags BadgeV2
     * @name GetBadgeVerifiers
     * @summary Get badge verifiers
     * @request GET:/v2/badges/verifiers
     */
    getBadgeVerifiers: (
      query: {
        /** Platform identifier */
        platform: string;
        /** Condition type */
        type: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeVerifiersResponse,
        WebResultBadgeVerifiersResponse
      >({
        path: `/v2/badges/verifiers`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed information of a specific badge series
     *
     * @tags BadgeV2
     * @name GetBadgeSeriesDetail
     * @summary Get badge series detail
     * @request GET:/v2/badges/series/{series}
     */
    getBadgeSeriesDetail: (
      series: string,
      query?: {
        /** claim status */
        status?: string;
        /** badge business type */
        businessType?: string;
        /** token Id array */
        tokenIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeSeriesDetailResponse,
        WebResultBadgeSeriesDetailResponse
      >({
        path: `/v2/badges/series/${series}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get user's claimed and claimable badge assets
     *
     * @tags BadgeV2
     * @name GetUserBadgeAssets
     * @summary Get user badge assets
     * @request GET:/v2/badges/assets
     */
    getUserBadgeAssets: (
      query?: {
        /**
         * Badge status include claimable
         * @default false
         */
        includeClaimable?: boolean;
        /** Return strategy (BADGE_ALL: return all badges, BADGE_MAX: return highest level per series, BADGE_REWARD: sort by reward) */
        strategy?: string;
        /** Badge series filter */
        series?: string[];
        /**
         * Number of items per page
         * @format int32
         */
        limit?: number;
        /** Pagination token */
        nextToken?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultBadgeAssetsResponse, WebResultBadgeAssetsResponse>({
        path: `/v2/badges/assets`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Check which badges the user can claim
     *
     * @tags BadgeV2
     * @name CheckUserClaimableBadges
     * @summary Check user claimable badges
     * @request POST:/v2/badges
     */
    checkUserClaimableBadges: (
      data: BadgeCheckRequest,
      params: RequestParams = {},
    ) =>
      this.request<WebResultBadgeCheckResponse, WebResultBadgeCheckResponse>({
        path: `/v2/badges`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description query badges by conditions
     *
     * @tags BadgeV2
     * @name QueryBadges
     * @summary query badges by conditions
     * @request GET:/v2/badges
     */
    queryBadges: (
      query?: {
        /** include badges token ids */
        ids?: string[];
        /** query type(COMMON: 根据传入的条件查询, HOTSPOT: 查询公告中配置的badge), 默认: COMMON */
        queryType?: string;
        /** only return imprint info */
        onlyImprint?: boolean;
        /** include progress info, default is false */
        includeProgress?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgesCompositeResponse,
        WebResultBadgesCompositeResponse
      >({
        path: `/v2/badges`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed information of a specific badge category
     *
     * @tags BadgeV2
     * @name CategoriesDetail
     * @summary Get badge detail by category
     * @request GET:/v2/badges/categories/{category}
     */
    categoriesDetail: (
      category: string,
      query?: {
        /** series identifier */
        series?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeCategoryDetailResponse,
        WebResultBadgeCategoryDetailResponse
      >({
        path: `/v2/badges/categories/${category}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description Query badge series with optional filtering conditions
     *
     * @tags BadgeV2
     * @name GetBadgeSeries
     * @summary Query badge series with conditions
     * @request GET:/v2/badges/series
     */
    getBadgeSeries: (
      query?: {
        /** include badges */
        includeBadges?: boolean;
        /** include badges status */
        status?: string;
        /** include badges business type */
        businessType?: string;
        /**
         * include badges limit
         * @format int32
         */
        limit?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<WebResultBadgeSeriesResponse, WebResultBadgeSeriesResponse>({
        path: `/v2/badges/series`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * @description anchor user info query
     *
     * @tags AnchorV2
     * @name AnchorUserInfo
     * @summary anchor user info query
     * @request GET:/v2/user
     */
    anchorUserInfo: (params: RequestParams = {}) =>
      this.request<WebResultUserInfoResponse, any>({
        path: `/v2/user`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * @description anchor mint
     *
     * @tags AnchorV2
     * @name Mint
     * @summary anchor mint
     * @request POST:/v2/mint/{type}
     */
    mint: (type: string, data: NFTMintRequestVO, params: RequestParams = {}) =>
      this.request<MintResponse, any>({
        path: `/v2/mint/${type}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description anchor batch mint
     *
     * @tags AnchorV2
     * @name BatchMint
     * @summary anchor batch mint
     * @request POST:/v2/batch/mint/{type}
     */
    batchMint: (
      type: string,
      data: BatchMintRequestVO,
      params: RequestParams = {},
    ) =>
      this.request<MintResponse, any>({
        path: `/v2/batch/mint/${type}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get signatures required for claiming badges
     *
     * @tags BadgeV2
     * @name GetBadgeClaimSignatures
     * @summary Get badge claim signatures
     * @request POST:/v2/badges/signatures
     */
    getBadgeClaimSignatures: (
      data: BadgeClaimSignatureRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeClaimSignatureResponse,
        WebResultBadgeClaimSignatureResponse
      >({
        path: `/v2/badges/signatures`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Check if a specific badge is claimable for the user
     *
     * @tags BadgeV2
     * @name CheckSingleBadgeClaimable
     * @summary Check single badge claimable status
     * @request POST:/v2/badges/{badgeId}
     */
    checkSingleBadgeClaimable: (
      badgeId: string,
      data: BadgeSingleCheckRequest,
      params: RequestParams = {},
    ) =>
      this.request<
        WebResultBadgeClaimSignatureResponse,
        WebResultBadgeClaimSignatureResponse
      >({
        path: `/v2/badges/${badgeId}`,
        method: "POST",
        body: data,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * @description Get detailed information of a specific badge
     *
     * @tags BadgeV2
     * @name GetBadgeDetail
     * @summary Get badge detail
     * @request GET:/v2/badges/{badgeId}
     */
    getBadgeDetail: (badgeId: string, params: RequestParams = {}) =>
      this.request<WebResultBadgeDetailResponse, WebResultBadgeDetailResponse>({
        path: `/v2/badges/${badgeId}`,
        method: "GET",
        format: "json",
        ...params,
      }),
  };
}
